// contexts/ErrorContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [errorModal, setErrorModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    status: null,
    error: null,
    context: null,
    icon: true,
  });

  const handleError = useCallback((error, context = {}) => {
    console.error('Error:', error, context, error?.status);
    
    const status = error?.status || error?.response?.status || null;
    let errorMessage = error?.message || 'Произошла ошибка при выполнении операции';
    
    // Получаем сообщение от сервера если есть
    if (error?.data?.error) {
      errorMessage = error.data.error;
    }
    
    let errorTitle = 'Ошибка';
    
    if (status) {
      switch (status) {
        case 400:
          errorTitle = 'Ошибка в данных';
          break;
        case 401:
          errorTitle = 'Не авторизован';
          errorMessage = 'Пожалуйста, войдите в систему';
          break;
        case 403:
          errorTitle = 'Доступ запрещен';
          break;
        case 404:
          errorTitle = 'Не найдено';
          break;
        case 409:
          errorTitle = 'Конфликт данных';
          break;
        case 429:
          errorTitle = 'Слишком много запросов';
          break;
        case 500:
          errorTitle = 'Ошибка сервера';
          break;
        default:
          errorTitle = `Ошибка ${status}`;
      }
    }
    
    setErrorModal({
      isOpen: true,
      title: errorTitle,
      message: errorMessage,
      status,
      error,
      context, 
      icon: true,
    });
  }, []);

  const closeErrorModal = useCallback(() => {
    setErrorModal(prev => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <ErrorContext.Provider value={{ errorModal, handleError, closeErrorModal }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within ErrorProvider');
  }
  return context;
};